// frontend/src/components/admin/tenants/ouTree/types.ts
/**
 * Tipos da arvore mesclada que renderiza /admin/tenants.
 *
 * MergedTreeNode e a uniao discriminada que o buildTenantOuTree
 * devolve. Os componentes recursivos (OuBranchNode, OrphansBranchNode)
 * fazem switch em `type` pra escolher o render.
 */
import type { AwsOuNode } from '@/api/awsOrgProvisioning'
import type { TenantRow } from '../TenantsTable'

export interface OuTreeBranch {
  type: 'ou'
  node: AwsOuNode
  children: MergedTreeNode[]
  /**
   * True quando ha busca ativa E (o name/ou_id casa OU algum descendente
   * account casa). Usado pelo render pra auto-expandir o ramo.
   */
  matchesSearch: boolean
}

export interface OuTreeAccountLeaf {
  type: 'account'
  tenant: TenantRow
}

export interface OuTreeOrphanRoot {
  type: 'orphan_root'
  children: OuTreeAccountLeaf[]
}

export type MergedTreeNode = OuTreeBranch | OuTreeAccountLeaf | OuTreeOrphanRoot

export interface BuildOptions {
  /**
   * True quando ha busca/filtro ativo. Quando true, ramos sem accounts
   * sao podados. Quando false, todas as Sub-UOs aparecem (incluindo vazias).
   */
  pruneEmptyParents: boolean
  /**
   * Texto de busca (pode ser undefined ou ''). Quando preenchido, popula
   * matchesSearch nos nos OU.
   */
  searchQuery?: string
}

/** Conta accounts no sub-tree recursivamente. Util para pruning e contador. */
export function countAccounts(node: MergedTreeNode): number {
  if (node.type === 'account') return 1
  if (node.type === 'ou') {
    return node.children.reduce((acc, c) => acc + countAccounts(c), 0)
  }
  // orphan_root
  return node.children.length
}
